import React from "react";
import { fileUrl } from "../lib/api";
import { useLang } from "../context/LangContext";
import { IdentificationCard } from "@phosphor-icons/react";

const BADGE = {
  blue: "bg-blue-100 text-blue-700 border-blue-300",
  green: "bg-green-100 text-green-700 border-green-300",
  grey: "bg-zinc-100 text-zinc-700 border-zinc-300",
  other: "bg-amber-100 text-amber-700 border-amber-300",
};

export const isPass = (d) => d.kind === "security_pass";

export const PassList = ({ documents }) => {
  const { t } = useLang();
  const passes = (documents || []).filter(isPass);
  if (passes.length === 0) return <p className="text-sm text-zinc-400">{t("passes_none")}</p>;
  return (
    <div data-testid="security-passes" className="space-y-2">
      {passes.map((d, i) => (
        <a key={i} data-testid={`pass-item-${i}`} href={fileUrl(d.path)} target="_blank" rel="noreferrer"
          className="flex items-center gap-2 text-sm text-zinc-700 hover:text-[#E11D2A]">
          <IdentificationCard size={18} weight="duotone" className="text-[#E11D2A] shrink-0" />
          <span className={`text-xs px-2 py-0.5 rounded-full font-semibold border ${BADGE[d.label] || BADGE.other}`}>{t(`pass_${d.label || "other"}`)}</span>
          <span className="truncate">{d.name}</span>
        </a>
      ))}
    </div>
  );
};
